/**
 * The countries the admin works in, each with the currency it uses.
 *
 * The backend only knows currencies, so the portal keeps this list. Only Saudi
 * Arabia and Jordan are live.
 */
export const ADMIN_COUNTRIES = [
  { code: "SA", name: "Saudi Arabia", currency: "SAR" },
  { code: "JO", name: "Jordan", currency: "JOD" },
] as const;

export type AdminCountry = (typeof ADMIN_COUNTRIES)[number];
export type AdminCountryCode = AdminCountry["code"];

export const DEFAULT_ADMIN_COUNTRY_CODE: AdminCountryCode = "SA";

export const findAdminCountry = (
  code: string | null | undefined
): AdminCountry | undefined =>
  ADMIN_COUNTRIES.find(country => country.code === code);
